import React, { useState, useEffect } from "react";
import { Table, Spin, Popconfirm } from "antd";
import { DeleteTwoTone, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./contactStyles.css";
import EditableImage from "../icons/EditIcon";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Axios from "../../api/Axios";
import { message, Pagination } from "antd";
import "react-phone-number-input/style.css";
import { remainingViewportHeight } from "../icons/ApplicationColor";
import { useSelector } from "react-redux";
import CommonTopDetails from "./CommonTopDetails";
// import { GetFormattedDate } from "../utils/DateTimeUtils";

const UsersTableCustomer = () => {
  const { id } = useParams();
  const [data, setData] = useState();

  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const updateAuth = false;
  const [messageApi, contextHolder] = message.useMessage();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/contactslist/${id}/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const handleRowClick = (record) => {
    history(
      `/admin-manager/customers/relationships/${id}/edit-contact/${record.id}/${id}`
    );
  };
  const [itemsLength, setItemsLength] = useState();
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Conatct has been Deleted.",
      duration: 5,
    });
    LoadContacts();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Conatct has been not been deleted.",
      duration: 5,
    });
  };
  const handleDelete = async (record) => {
    //console.log("coming here", record.id);
    try {
      await Axios.delete(`/contacts/${record.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const renderAcess = (text, record) => {
    if (record.access) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      fixed: "left",
      width: 120,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      fixed: "left",
      width: 120,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 250,
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
    },
    {
      title: "Position",
      dataIndex: "job_title",
      key: "job_title",
      width: 120,
    },
    // {
    //   title: "Products",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (products) => (
    //     <>
    //       {products.map((product) => {
    //         let color = product.length > 5 ? "geekblue" : "green";
    //         if (product === "Product A") {
    //           color = "volcano";
    //         }
    //         return (
    //           <Tag color={color} key={product}>
    //             {product.toUpperCase()}
    //           </Tag>
    //         );
    //       })}
    //     </>
    //   ),
    // },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" })
          .toUpperCase();
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        return formattedDate;
      },
    },
    {
      title: "Last Update",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 120,
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" })
          .toUpperCase();
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        return formattedDate;
      },
    },

    {
      title: "Access",
      dataIndex: "access",
      key: "access",
      width: 70,
      render: renderAcess,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 70,
      render: renderStatus,
    },
    ...(updateAuth
      ? [
          {
            title: "Action",
            key: "action",
            fixed: "right",
            align: "center",
            width: 100,
            render: (text, record) => (
              <div
                key={record.id}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <EditableImage
                  key="edit"
                  handleRowClick={handleRowClick}
                  recordId={record}
                  title="edit"
                />
                <Popconfirm
                  title={"Delete Contact"}
                  description=" "
                  onConfirm={() => handleDelete(record)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    key="delete"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];

  const history = useNavigate();

  // const LoadApplications = async () => {
  //   console.log(id);
  //   try {
  //     const res = await Axios.get(`/nonorgproducts/${id}/`);
  //     console.log(res.data);
  //     setApplications(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // useEffect(() => {
  //   LoadApplications();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  return (
    <div>
      {contextHolder}
      <CommonTopDetails
        title="Contacts"
        titleSuffix={`${itemsLength || 0} contact(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: `/admin-manager/customers/relationships/${id}/add-contact/${id}`,
        }}
        marginPass="15px"
      />

      {/* <div className="form-container-3"> */}
      <Spin spinning={loading}>
        <div className="form-container-2">
          <Table
            size="small"
            rowKey="id"
            dataSource={data}
            columns={columns}
            bordered
            className="table-container"
            style={{ margin: "1rem" }}
            pagination={false}
            scroll={{
              y: `${remainingViewportHeight(36)}px`,
              x: 1000,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      {/* </div> */}
    </div>
  );
};

export default UsersTableCustomer;
